export default __webpack_public_path__ + "35f807a5d9b26a5377b52c0e70e6d7b8.png";